import $ from "jquery";
import React, { useEffect, useState } from 'react';
import Toastr from 'toastr';
import SessionManager from '../../routes/SessionManager';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function NavbarLogin(props) {

    const [user, setUser] = useState({});
    const [user_login, setUserLogin] = useState('');
    const [user_pass, setUserPass] = useState('');

    useEffect(() => {
        let user = undefined;
        if (user) {
            setUser(user);
        }
    }, []);

    const handleInputChange = ({ target }) => {
        switch (target.name) {
            case "user_login":
                setUserLogin(target.value);
                break;
            case "user_pass":
                setUserPass(target.value);
                break;
            default:
                break;
        }
    }

    const handleLogin = (e) => {
        if (user_login === '' || user_pass === '') {
            Toastr.error('Missing credentials', 'Invalid Input ...');
            return;
        }
        $('#login-btn').val('Authenticating ...').attr('disabled', true);
        $('#spinner').toggleClass("d-none");
        CommonUtils.ajax(
            {
                url: API.AUTH.AUTHENTICATE,
                type: 'GET',
                headers: {
                    user_login: (user_login).toLowerCase(),
                    user_pass: user_pass,
                    app_name: 'SITESUPT'
                },
                dataType: "json"
            }
        ).then(async (res) => {

            if (res.status && res.status.code === 200) {
                $('#spinner').toggleClass("d-none");
                Toastr.success('Welcome on SiteSupt OnDemand', 'Welcome !');
                setTimeout(function () {
                    var userData = res.data;
                    let deleteAtts = ['site_selected', 'zones', 'site_locations'];
                    for (let att of deleteAtts) {
                        delete userData[att];
                    }
                    if (!userData.user_sites) {
                        userData.user_sites = [userData.site_id];
                    }
                    var sessionManager = new SessionManager();
                    sessionManager.storeCookie(
                        'user',
                        userData
                    );
                    if (window.location.search.indexOf('redirectUrl') !== -1) {
                        window.location = '.' + window.location.search.replace('?redirectUrl=', '');
                    } else {
                        if (userData.defaultView === 'Site Map') {
                            window.location = '/sitemap';
                        }
                        else {
                            window.location = './dashboard';
                        }
                    }

                }, 1000);
            } else {
                if (res.status && res.status.code === 201) {
                    Toastr.error('Please try again ...', 'Invalid credentials');
                }
                $('#spinner').toggleClass("d-none");
                $('#login-btn').val('Login').removeAttr('disabled');
            }
        }).then((res) => {
            $('#login-btn').val('Login').removeAttr('disabled');
        });

        return false;
    }

    return (user && user.user_name ? "" :
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 font-size-12 text-warning text-left app-slogan">
                    Eliminating Paperwork, So You Can Get Back To Building
                </div>
                <div className="col-md-12 mt-2-neg">
                    <form className="form-inline pull-right" method="post" onSubmit={(e) => { e.preventDefault(); handleLogin(e) }}>
                        <input name="user_login" onChange={handleInputChange} className="form-control mr-2 mb-2" type="username" value={user_login} autoComplete="off" placeholder="Email / User Name" autoFocus />
                        <input name="user_pass" onChange={handleInputChange} className="form-control mr-2 mb-2" type="password" value={user_pass} autoComplete="off" placeholder="Password" />
                        <button id="login-btn" className="btn btn-sm btn-primary mb-2" type="submit">
                            <i id="spinner" className="fa fa-circle-notch fa-spin d-none"></i> Login
                        </button>
                        <a href="/" className="px-2 color-white forgotPassword text-primary">Forgot Password ?</a>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
}

export default NavbarLogin;